import { apiClient } from '../../base/ApiClients'
import { DefaultContactFormValues, DefaultContactFormValuesWithId, IDefaultContact } from '../../../models/IContact'
import { useMutation } from 'react-query'

// Default contacts
export const GetDefaultContact = async (id: any) => {
  const { data } = await apiClient.get<IDefaultContact>(`website-default-contact/${id}`);
  return data;
}

export const GetDefaultContacts = async () => {
  const { data } = await apiClient.get<IDefaultContact[]>('website-default-contact');
  return data;
}

const CreateDefaultContact = async (values: DefaultContactFormValues) => {
  return await apiClient.post('website-default-contact', values);
}

export const useCreateDefaultContactMutation = () => useMutation(CreateDefaultContact, {});

const EditDefaultContact = async (values: DefaultContactFormValuesWithId) => {
  return await apiClient.put(`website-default-contact/${values.id}`, values.values);
}

export const useEditDefaultContactMutation = () => useMutation(EditDefaultContact, {});

const DeleteDefaultContact = async (id: string) => {
  return await apiClient.delete(`website-default-contact/${id}`)
}

export const useDeleteDefaultContactMutation = () => useMutation(DeleteDefaultContact, {});
// End default contacts